import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Button } from '@mui/material';
import { useRewardCart } from '@src/hooks/contexts';
import styles from '@src/components/MediaList/RewardButton.module.less';

const STATUS_CONFIG = {
  pending: {
    text: 'SENDING',
    color: 'warning',
    tooltip: 'Gift card has been paid and will be sent soon',
  },
  processing: {
    text: 'SENDING',
    color: 'warning',
    tooltip: 'Gift card is being processed',
  },
  sent: {
    text: 'GIFT SENT',
    color: 'success',
    tooltip: 'Gift card has been sent',
  },
  redeemed: {
    text: 'GIFT REDEEMED',
    color: 'secondary',
    tooltip: 'Gift card has been redeemed',
  },
  failed: {
    text: 'SEND FAILED',
    color: 'error',
    tooltip: 'Gift card send failed',
  },
};

const RewardButton = ({ submission, giftCardSent, rewardEnabled }) => {
  const { isInCart, addToCart, removeFromCart, openCart } = useRewardCart();
  const approved = isInCart(submission?.campaignSubmissionId);
  const giftOrderStatus = submission?.giftOrderStatus;

  if (!rewardEnabled) {
    return null;
  }

  const statusKey = giftCardSent && !giftOrderStatus ? 'sent' : giftOrderStatus;
  const statusInfo = STATUS_CONFIG[statusKey];

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (approved) {
      removeFromCart(submission?.campaignSubmissionId);
    } else {
      addToCart(submission);
      setTimeout(() => openCart(), 100);
    }
  };

  if (statusInfo) {
    const statusClass = `${styles.statusButton} ${styles[statusKey] || ''}`;
    
    return (
      <Tooltip title={statusInfo.tooltip}>
        <Button
          size="small"
          variant="outlined"
          color={statusInfo.color}
          className={statusClass}
          disabled
        >
          {statusInfo.text}
        </Button>
      </Tooltip>
    );
  }
  
  const rewardAmount = submission?.campaignRewardAmount || 0;
  const buttonText = approved ? 'IN CART' : 'APPROVE GIFT';
  const buttonColor = approved ? 'error' : 'primary';
  const tooltipText = approved 
    ? `Remove from cart ($${rewardAmount})` 
    : `Add to cart${rewardAmount > 0 ? ` ($${rewardAmount})` : ''}`;

  return (
    <Tooltip title={tooltipText}>
      <Button
        size="small"
        variant="outlined"
        color={buttonColor}
        className={styles.statusButton}
        onClick={handleToggle}
      >
        {buttonText}
      </Button>
    </Tooltip>
  );
};

RewardButton.propTypes = {
  submission: PropTypes.shape({
    campaignSubmissionId: PropTypes.string.isRequired,
    submitterName: PropTypes.string,
    campaignName: PropTypes.string,
    submitterEmail: PropTypes.string,
    campaignId: PropTypes.number,
    campaignRewardAmount: PropTypes.number,
    giftOrderStatus: PropTypes.oneOf(['pending', 'processing', 'sent', 'redeemed', 'failed']),
  }).isRequired,
  giftCardSent: PropTypes.bool.isRequired,
  rewardEnabled: PropTypes.bool.isRequired,
};

export default RewardButton;



// WEBPACK FOOTER //
// ./src/components/MediaList/RewardButton.jsx